import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import * as FaIcons from "react-icons/fa";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || import.meta.env.VITE_API_BASE_URL;

const Services = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  // Language sync logic
  const [lang, setLang] = useState(localStorage.getItem("lang") || "en");

  useEffect(() => {
    // Sync language with Header switch
    const handleStorageChange = () => {
      const currentLang = localStorage.getItem("lang") || "en";
      setLang(currentLang);
    };

    window.addEventListener("storage", handleStorageChange);
    const interval = setInterval(handleStorageChange, 500);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/services`);
        if (res.data.success) {
          // Sort by order field
          const sortedData = [...res.data.data].sort(
            (a, b) => (a.order || 0) - (b.order || 0),
          );
          setServices(sortedData.slice(0, 6));
        }
      } catch (err) {
        console.error("Error fetching services:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchServices();
  }, []);

  if (loading) return null;

  return (
    <section className="py-12 overflow-hidden transition-colors duration-500   bg-[#999999]/10">

  <div className="px-6 mx-auto max-w-7xl md:px-12">

    {/* Section Header */}
    <div className="mx-auto mb-16 text-center">

      <span className="text-[#B08D57] uppercase tracking-[0.3em] font-semibold text-[11px] mb-4 block font-arial">
        {lang === "en" ? "What We Offer" : "我们提供"}
      </span>

      <h2 className="mb-3 text-[28px] md:text-[34px]  text-[#1A1A1A]   leading-tight  font-century">
        {lang === "en" ? "Comprehensive Corporate Solutions " : "全面的 企业解决方案"}{" "}
       
        {lang === "en"
          ? "for Every Stage of Your Business"
          : "适用于您业务的每个阶段"}
      </h2>

    </div>

    {/* Services Grid */}
    <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 items-stretch">

      {services.map((service) => {
        const IconComponent =
          FaIcons[service.iconName] || FaIcons.FaBriefcase;

        return (
          <Link to="/services" key={service._id} className="h-full">
            <div
              className="h-full flex flex-col justify-between p-10 border cursor-pointer group relative overflow-hidden 
              transition-all duration-500 ease-out will-change-transform transform-gpu
              bg-white border-[#eaeaea] 
              hover:shadow-[0_20px_60px_-20px_rgba(0,0,0,0.15)] hover:-translate-y-1"
            >

              {/* TOP CONTENT */}
              <div>

                {/* hover overlay */}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-500 bg-gradient-to-br from-[#B08D57]/5 to-transparent"></div>

                {/* ICON */}
                <div className="w-14 h-14 rounded-full flex items-center justify-center mb-8 
                bg-[#1A1A1A] text-white 
                transition-all duration-500 group-hover:bg-[#B08D57] group-hover:text-white">
                  <IconComponent size={22} />
                </div>

                {/* TITLE */}
                <h3 className="text-xl font-century font-semibold mb-4 text-[#B08D57]">
                  {lang === "en" ? service.title.en : service.title.zh}
                </h3>

                {/* DESC */}
                <p className="text-[14px] md:text-[16px] text-[#666666] leading-relaxed mb-8 line-clamp-3">
                  {lang === "en"
                    ? service.description.en
                    : service.description.zh}
                </p>

              </div>

              {/* BOTTOM LINK (always same position) */}
              <div className="text-[12px] tracking-wide font-semibold flex items-center gap-2 text-[#B08D57] transition-all">
                {lang === "en" ? "Learn More" : "了解更多"}
                <span className="transition-transform duration-300 group-hover:translate-x-1">
                  →
                </span>
              </div>

            </div>
          </Link>
        );
      })}

    </div>

  </div>
</section>
  );
};

export default Services;
